/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />
/// <reference path="../../components/baseClasses/dataMaintenanceContextBase.ts" />
/// <reference path="../../components/common/utilities.ts" />

module Meevo.Plugins.Memberships {
    'use strict';

    import PromiseChain = Meevo.Components.Common.PromiseChain;
    import MaintenanceFormState = Meevo.Model.MaintenanceFormState;

    export class MembershipsContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        fileTypesEnum = Meevo.Model.FileTypes;

        constructor(protected $scope: ng.IScope,
                    appSettings: Meevo.Components.Common.IAppSettings,
                    dataService: Meevo.Components.BaseClasses.IDataService,
                    modalService: Meevo.Components.Modal.IModalService,
                    identityService: Meevo.Components.Common.IIdentityService,
                    loggingService: Meevo.Components.Logging.ILoggingService,
                    securityChecker: Meevo.Components.Common.ISecurityService,
                    trackingService: Meevo.Components.Tracking.ITrackingService,
                    protected busyService: Meevo.Components.Busy.IBusyService,
                    protected $translate: angular.translate.ITranslateService,
                    protected $q: angular.IQService) {

            super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService, null, false);

            this.baseEndpoint = appSettings.API_ENDPOINTS.memberships;
            this.sectionTemplatePath = "app/plugins/memberships/sectionViews/";

            this.buildCrudSecurityKeys(this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_MAIN);
            this.entityType = 'Membership';
            this['membershipLengthEnum'] = Meevo.Model.MembershipLengthEnum;
            this['billingTypeEnum'] = Meevo.Model.BillingTypeEnum;
            this['recurringPaymentScheduleEnum'] = Meevo.Model.RecurringPaymentScheduleEnum;
            this['autoRenewTypeEnum'] = Meevo.Model.AutoRenewTypeEnum;
            this['memberTypeEnum'] = Meevo.Model.MemberTypeEnum;

            this.initializeSections();
            this.loadMembershipTypes()
                .then((data) => {
                    this.busyService.stop();
                    if (data.length === 0) {
                        this.goToMembershipTypesPage();
                    }
                });
            this.$scope.$watch(() => {
                this.isLoading ? this.busyService.start() : this.busyService.stop();
                if (!this.$scope.memberships.context.isAccessible) {
                    if (!this.isReadonly && _.isEmpty(this.modelBackup)) {
                        this.selectedSection.preSave();
                        this.modelBackup = angular.toJson(this.selectedSection.model);
                    } else if (this.isReadonly && !_.isEmpty(this.modelBackup)) {
                        this.modelBackup = {};
                    }
                }
            });
        }
        canChangeFreezeFees: boolean = false;
        modelBackup: any;
        private pendingSave: angular.IPromise<any>;
        private static readonly SAVE_STOPPED_UNLIMITED_RECURRING_RENEWAL_PACKAGE = 'Membership save stopped: unlimited service package on recurring / renewal fee';

        get showDelete() {
            return false;
        }

        initializeSections(): void {
            let baseSectionProps: Meevo.Model.ISectionParamsBaseDataService = {
                sectionId: 0,
                displayNameContentKey: '',
                template: '',
                isPrimarySection: false,
                handlesOwnCrud: false,
                baseEndpoint: '',
                sectionEndpoint: '',
                loggingService: this.loggingService,
                dataService: this.dataService,
                sectionSecurityKey: ''
            };

            // Adding sections items that represent areas in the maintenance form
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                // Validate key CHANGEFREEZEFEES for use case when set HIDE need show as DENY
                this.canChangeFreezeFees = this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIP_FIELD_CHANGEFREEZEFEES + Meevo.Components.Common.SecurityParts.KEY_PART_READ);


                this.sections.push(new MainSection(
                    _.extend({}, baseSectionProps, {
                        displayNameContentKey: 'SECTION_MAIN',
                        template: 'main.html',
                        isPrimarySection: true,
                        handlesOwnCrud: false,
                        baseEndpoint: this.baseEndpoint,
                        identityService: this.identityService,
                        noun: Meevo.Model.NounEnum.MembershipMain,
                        $translate: this.$translate,
                        modalService: this.modalService,
                        sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
                        $q: this.$q,
                        securityChecker: this.securityChecker
                    })));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ) && !this.identityService.inCentralOfficeMode()) {
                this.sections.push(new CompensationSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 1,
                        displayNameContentKey: 'SECTION_MEMBERSHIP_DEF_COMPENSATION',
                        template: 'compensation.html',
                        isPrimarySection: false,
                        handlesOwnCrud: false,
                        baseEndpoint: this.baseEndpoint,
                        sectionEndpoint: 'Compensation',
                        identityService: this.identityService,
                        noun: Meevo.Model.NounEnum.MembershipCompensation,
                        modalService: this.modalService,
                        sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    })));
            }

            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new NotesSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 2,
                        displayNameContentKey: 'HEADER_NOTES',
                        template: 'notes.html',
                        isPrimarySection: false,
                        handlesOwnCrud: false,
                        baseEndpoint: this.baseEndpoint,
                        identityService: this.identityService,
                        noun: Meevo.Model.NounEnum.MembershipDocsAndForms,
                        modalService: this.modalService,
                        sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_NOTES + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    })));
            }
            /*
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(new DocsFormsSection(
                    _.extend({}, baseSectionProps, {
                        sectionId: 2,
                        displayNameContentKey: 'SECTION_MEMBERSHIP_DEF_DOCS',
                        template: 'docsForms.html',
                        isPrimarySection: false,
                        handlesOwnCrud: false,
                        baseEndpoint: this.baseEndpoint,
                        identityService: this.identityService,
                        noun: Meevo.Model.NounEnum.MembershipDocsAndForms,
                        modalService: this.modalService,
                        sectionSecurityKey: this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    })));
            }
            */

            // this.$scope.$watch(() => {
            //     if (this.selectedSection.model && this.selectedSection.model.hasOwnProperty('membershipTypeDetail')) {
            //         return this.selectedSection.model['membershipTypeDetail'];
            //     }
            // }, (newVal, oldVal) => {
            //     if (newVal && newVal !== oldVal) {
            //         if (newVal.hasOwnProperty('businessTypeId')) {
            //             this.businessTypeFilter.onlyId = newVal['businessTypeId'];
            //         }
            //     }
            // }, true);
        }

        selectSection(item): void {
            switch (item.sectionId) {
                case 1:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_COMMISSION);
                    break;
                case 2:
                    this.buildCrudSecurityKeysBase(this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_NOTES);
                    break;
                default:
                    this.buildCrudSecurityKeys(this.securityKeys.MEMBERSHIP_MEMBERSHIP_TAB_MAIN);
                    break;
            }
            super.selectSection(item);
        }

        detectChanges(): any {
            if (!this.$scope.memberships.context.isAccessible) {
                this.selectedSection.preSave();
                let section = this.selectedSection;
                let preSavedModel = angular.toJson(section.model);
                let modelCompare = _.isEqual(this.modelBackup, preSavedModel);
                if (modelCompare) {
                    super.cancel();
                    return;
                }
            }
        }

        /**
         * Override base save method
         * */
        save(): angular.IPromise<any> {
            // A second click while the checks below are still waiting on the server or the user would run them twice.
            if (this.pendingSave) {
                return this.pendingSave;
            }

            let section = this.selectedSection;
            this.detectChanges();
            if (section instanceof MainSection && section.preSaveValidation && _.isFunction(section.preSaveValidation)) {
                let isValid = section.preSaveValidation();
                if (!isValid) {
                    return;
                }
            }

            const promises = new PromiseChain(this.$q);
            // Deactivating keeps the stored packages: it goes straight to the server, which accepts the packages already stored
            // and still rejects any unlimited recurring / renewal package this save adds.
            if (section instanceof MainSection && this.canSave && !section.isBeingDeactivated()) {
                promises.push(() => this.stopSaveIfUnlimitedRecurringRenewalPackages(section as MainSection));
            }
            if (section instanceof MainSection && this.mode === MaintenanceFormState.Adding) {
                promises.push(() => (section as MainSection).asyncValidationOnCreate())
            }

            this.pendingSave = promises.then(
                () => super.save(),
                (reason) => {
                    if (reason !== MembershipsContext.SAVE_STOPPED_UNLIMITED_RECURRING_RENEWAL_PACKAGE) {
                        console.error(reason);
                    }
                },
                () => this.pendingSave = null);
            return this.pendingSave;
        }

        /**
         * Tells the user and drops recurring / renewal packages that became unlimited, then stops the save
         * so the user saves the corrected definition.
         * */
        private stopSaveIfUnlimitedRecurringRenewalPackages(section: MainSection): ng.IPromise<any> {
            // Busy overlay while the server is asked, so Cancel can't roll the form back mid-check.
            this.loadingInProgress = true;
            return section.getUnlimitedRecurringRenewalPackageIds()
                .finally(() => this.loadingInProgress = false)
                .then((unlimitedPackageIds) => {
                if (unlimitedPackageIds.length === 0) {
                    return;
                }

                return this.modalService.alert('MESSAGE_MEMBERSHIP_UNLIMITED_PACKAGE_RECURRING_RENEWAL').then(() => {
                    section.removeRecurringRenewalPackages(unlimitedPackageIds);
                    return this.$q.reject(MembershipsContext.SAVE_STOPPED_UNLIMITED_RECURRING_RENEWAL_PACKAGE);
                });
            });
        }

        updateAfterUnsuccessSave(): void {
            let section = this.selectedSection;

            if (section instanceof MainSection) {
                section.checkUnlimitedServices(false);
            }
        }

        loadMembershipTypes(): ng.IPromise<Array<Meevo.Model.MembershipType>> {
            let params = {
                "pageNumber": 0,
                "itemsPerPage": 20,
                "criteria": {
                    "includeActive": true
                }
            };

            this.busyService.start();

            return this.dataService.getListPaged('membershipType', params);
        }

        goToMembershipTypesPage(): void {
            this.modalService.alert('MESSAGE_EMPTY_MEMBERSHIP_TYPES_LIST')
                .then(() => {
                    this.$scope.$emit(Meevo.Components.Common.Messages.GOTO_STATE, {
                        stateName: this.appSettings.ROUTE_NAMES.membershipTypes,
                        stateParams: {
                            callback: null,
                            callbackState: null,
                            targetState: Meevo.Model.MaintenanceFormVisualState.Detail,
                            actionState: Meevo.Model.MaintenanceFormState.Adding
                        }
                    });
                })
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
            this.businessTypeDetail = model.businessTypeDetail;
            this.availableAtLocations = model.availableAtLocations;
        }

        postCopy(): void {
            super.postCopy();
            let model = this.castModel<Model.Membership>();
            model.displayName = undefined;
            model.shortcut = undefined;
            model.externalId = undefined;
        }

        private isCurrentLocation(locationId): boolean {
            return locationId === this.identityService.locationId;
        }

        public takeOwnershipClicked() {
            let packagesLists = [
                this.selectedSection['_enrollmentPackageSettings'],
                this.selectedSection['_recurringPackageSettings'],
                this.selectedSection['_renewalPackageSettings']
            ];
            let hasLocationOwned: boolean = false;

            packagesLists.forEach(pack => {
                pack.forEach((item) => {
                    if (this.isCurrentLocation(item.packageTypeLocationId)) {
                        hasLocationOwned = true;
                    }
                });
            });

            this.selectedSection.model['membershipMemberSettings'].forEach((item) => {
                if (item.membershipBenefitTemplateDetail && !this.isCurrentLocation(item.membershipBenefitLocationId)) {
                    hasLocationOwned = true;
                }
            });

            if (hasLocationOwned === false || !this.takeOwnership) {
                return;
            }

            this.modalService.confirm('MESSAGE_WILL_REMOVE_ANYTHING_LOCALLY_OWNED')
                .then((res) => {
                    if (res == true) {
                        this.selectedSection.model['membershipMemberSettings'].forEach((item) => {
                            if (item.membershipBenefitTemplateDetail && !this.isCurrentLocation(item.membershipBenefitLocationId)) {
                                item.membershipBenefitTemplateId = '';
                                item.membershipBenefitLocationId = '';
                                item.membershipBenefitTemplateDetail = null;
                            }
                        });

                        this.selectedSection['_enrollmentPackageSettings'] = this.selectedSection['_enrollmentPackageSettings'].filter((item) => {
                            return this.isCurrentLocation(item.packageTypeLocationId);
                        });
                        this.selectedSection['_recurringPackageSettings'] = this.selectedSection['_recurringPackageSettings'].filter((item) => {
                            return this.isCurrentLocation(item.packageTypeLocationId);
                        });
                        this.selectedSection['_renewalPackageSettings'] = this.selectedSection['_renewalPackageSettings'].filter((item) => {
                            return this.isCurrentLocation(item.packageTypeLocationId);
                        });
                    }
                });
        }

        get showEdit(): boolean {
            if (this.selectedSection instanceof NotesSection
                && (this.selectedSection.model.locationId !== this.selectedSection.model.homeLocationId
                    || this.selectedSection.model.locationId !== this.identityService.locationId)) {
                return false;
            } else {
                return super.showEditLogic();
            }
        }
    }
}
